export default __webpack_public_path__ + "static/media/MonthlyScreen.8f725fd3.gif";